var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-justify"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('lead-profile-tab-finance-invoice-history-table',{attrs:{"value":_vm.value}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }